import { IPgnMove } from '@libs/chess/pgn';
import { RedModal } from '@ui/components/RedModal/RedModal';

export function IvalidPgnMoveModal({ move }: { move: IPgnMove }) {
  return (
    <RedModal header={'Ошибка нотации'}>
      Невозможный ход {move.moveFull}
      {move.color === 'black' ? '...' : '.'} {move.san}
    </RedModal>
  );
}
